module.exports = __webpack_public_path__ + "img/secound_bg.05a35a83.png";